import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import NewBooking from "./NewBooking";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:4040/api";

// Thin wrapper: the create and edit screens are the same form (NewBooking),
// so edits get the full layout, sender/receiver, multi-item freight and
// livestock, documents and Owner's Risk handling with no duplicated code.
export default function EditBooking() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [booking, setBooking] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/bookings/${id}`);
        if (!res.ok) throw new Error(`Booking not found (${res.status})`);
        const data = await res.json();
        if (!cancelled) setBooking(data?.data || data);
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  if (error) {
    return (
      <div className="min-h-screen bg-slate-50 p-6">
        <div className="rounded-2xl border border-red-200 bg-red-50 px-5 py-4 text-sm text-red-700">{error}</div>
      </div>
    );
  }

  if (!booking) {
    return (
      <div className="min-h-screen bg-slate-50 p-6">
        <div className="rounded-2xl border border-slate-200 bg-white p-6 text-sm text-slate-600 shadow-sm">Loading booking...</div>
      </div>
    );
  }

  return (
    <NewBooking
      key={booking._id || id}
      editBookingId={id}
      initialData={booking}
      onSaved={() => navigate(`/dashboard/bookings/${id}`)}
    />
  );
}